import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import redirect from './middlewares/redirect';
import errors from './middlewares/errors';

const reduxDevTool = window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f; // eslint-disable-line

const middlewares = [
  thunk,
  redirect,
  errors,
];

export default (reducer, initState) => {
  const store = createStore(reducer, initState, compose(
    applyMiddleware(...middlewares),
    reduxDevTool,
  ));

  if (process.env.NODE_ENV !== 'production') {
    if (module.hot) {
      module.hot.accept('./rootReducer', () => {
        store.replaceReducer(reducer);
      });
    }
  }

  return store;
};
